import { render, staticRenderFns } from "./contact-jser.vue?vue&type=template&id=4f8c482c&scoped=true&"
var script = {}
import style0 from "./contact-jser.vue?vue&type=style&index=0&id=4f8c482c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8c482c",
  null
  
)

export default component.exports